import { BaseEntity } from '../../../app/core';

export class ComplaintGrid extends BaseEntity {
    id: number;
    sinisterId: number;
    date: Date;
    dateString: string;
    place: string;
    driverFile: string;
    domain: string;
    userName: string;
    internalNumber: number;
    complaintStateId: number;
    rejectionReason: string;
    complaintState: string;

    constructor(date: Date) {
        super();
        this.dateString = this.dateToString(date);
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/complaint/models/complaintGrid.ts